import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { Link, useParams } from 'react-router-dom'
import {
    AlertType, ProdAttributes, classInput, classLabel, classDivBackground, classInputDark, classLabelDark, TipoProduto,
    classbtVerde, classbtAzul, classDivBody, ProdImages, classBt, VariacaoProduto, Grupo, Marca, SubGrupo, UnidMedida, GradeProduto,
    classBorderLabelDark, classbtColunasAzul, classWeigthBt, barraVermelhoAzul, bgRed, bgBlue, focusRed, focusLabelRed,
    classbtColunasVermelho, classbtCinzaClaro, classDtCriarAtt, classUserCriarAtt, InputsRefs
} from '../../Utils/Types'
import { IoAddCircleSharp, IoCamera, IoHelpCircleOutline, IoSave, IoSearch } from 'react-icons/io5'
import { FcNook } from 'react-icons/fc'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faCamera, faFolder, faTable, faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { Icone } from '../../Components/Icones/Index'
import { ProdutoService } from './ProdutoService'
import { Funcoes } from '../../Utils/Funcoes'
import { OrigensMercadoria, TiposProdutos } from '../../Utils/Global'
import { ModalMarcaGrupo } from '../../Components/Modal/modalMarcaGrupo'
import { ModalUniMedida } from '../../Components/Modal/modalUnidMedida'
import { ModalSubGrupo } from '../../Components/Modal/modalSubGrupo'
import { ModalExcluirDados } from '../../Components/Modal/ModalExcluirDados'
import { GridEmpty } from '../../Components/GridEmpty/grid-empty'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import moment from 'moment'
import { ToolTips } from '../../Components/ToolTips/tooltips'
import { ModalCriarGrade } from '../../Components/Modal/modal-criar-grade'
import { FaFileDownload, FaRegQuestionCircle, FaTrashAlt } from 'react-icons/fa'
import { AiOutlineClear } from 'react-icons/ai'
import { Tooltip } from 'react-tooltip'
import { ModalImportacao } from '../../Components/Modal/modalImportacao'
import { selectUser } from '../../Components/Redux/userSlice'
import { useSelector } from 'react-redux'

type CampoObrigatorio = {
    campo: string,
    erro: boolean,
}

export const ProductsNew = () => {

    // -----------------------------------------------
    // ----------------- SEM USO ---------------------
    // -----------------------------------------------
    /*
    const [variacaoSelecionada, setVariacaoSelecionada] = useState<VariacaoProduto>()
    const [selectVariacaoVisible, setSelectVariacaoVisible] = useState(false)
    const [loadingSaveVariacao, setLoadingSaveVariacao] = useState<boolean>(false)
    const [disableSearchBoxVariacao, setDisableSearchBoxVariacao] = useState<boolean>(false)
    const [image, setImage] = useState('')
    const [imageStr, setImageStr] = useState('')
    const [crop, setCrop] = useState<Point>({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [range, setRange] = useState(0)
    const [modalCadImageShow, setModalCadImageShow] = useState<boolean>(true)
    const [subVariacaoSelecionada, setSubVariacaoSelecionada] = useState<VariacaoProduto>()
    const [modalVariacaoVisible, setModalVariacaoVisible] = useState(false)
    const [tipoRegistro, setTipoRegistro] = useState()
    const dispatch = useDispatch()
    */


    // ---------- TABS ---------------------------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Imagens', active: false, icon: faCamera },
        { index: 2, titulo: 'Grade', active: false, icon: faTable },
        { index: 3, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)

    // ---------- CAMPOS OBRIGATORIOS ------------------------------------------------
    const fieldsMandatory: CampoObrigatorio[] = [
        { campo: 'descricao', erro: false },    // Posição 0 do Array.
        { campo: 'unid', erro: false },         // Posição 1 do Array.
        { campo: 'gtrib', erro: false },        // Posição 2 do Array.    
        { campo: 'pvenda', erro: false },       // Posição 3 do Array.          
    ]

    const [CamposObrigatorios, setCamposObrigatorios] = useState<CampoObrigatorio[]>(fieldsMandatory)

    // ---------- ATRIBUTOS ----------------------------------------------------------
    const { idProd } = useParams()      // variavel que recebe o id do produto quando vai editar
    const { idProdDup } = useParams()   // variavel que recebe o id do produto quando vai duplicar
    const [id, setId] = useState(0)
    const [prodAttributes, setProdAttributes] = useState<ProdAttributes>()
    const [gradeAttributes, setGradeAttributes] = useState<VariacaoProduto[]>([])

    // COLUNA 1
    const [descricao, setDescricao] = useState("")
    const [descricaoCopia, setDescricaoCopia] = useState("")
    const [filterCodBarraType, setFilterCodBarraType] = useState('00')
    const [codBarra, setCodBarra] = useState("")
    const [referencia, setReferencia] = useState("")
    const [peso, setPeso] = useState("0,00")
    const [ncm, setNcm] = useState("")
    const [cest, setCest] = useState("")

    // COLUNA 2
    const [idGrupo, setIdGrupo] = useState(0)
    const [grupos, setGrupos] = useState<Grupo[]>([])
    const [idSGrupo, setIdSGrupo] = useState(0)
    const [sGrupos, setSGrupos] = useState<SubGrupo[]>([])
    const [idMarca, setIdMarca] = useState(0)
    const [marcas, setMarcas] = useState<Marca[]>([])
    const [idUnidMedida, setIdUnidMedida] = useState(0)
    const [unidMedidas, setUnidMedidas] = useState<UnidMedida[]>([])
    const [tributacao, setTributacao] = useState(0)
    const [tipo, setTipo] = useState<TipoProduto>("P")
    const [origem, setOrigem] = useState("")

    // COLUNA 3
    const [estoque, setEstoque] = useState("0,00")
    const [estoqueFisico, setEstoqueFisico] = useState("0,00")
    const [estoqueMinimo, setEstoqueMinimo] = useState("0,00")

    // COLUNA 4
    const [precoCusto, setPrecoCusto] = useState("0,00")
    const [precoVenda, setPrecoVenda] = useState("0,00")

    // COLUNA 5
    const [ativo, setAtivo] = useState("S")

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS IMAGEM ---------------------------------------------------
    const [imagens, setImagens] = useState<ProdImages[]>([])
    const [loadingImage, setLoadingImage] = useState(false)

    // ---------- ATRIBUTOS VARIACAO -------------------------------------------------
    const [variacaoList, setVariacaoList] = useState<VariacaoProduto[]>([])
    //const [tipoVariacao, setTipoVariacao] = useState<TipoVariacao>("V")
    //const [searchBoxVariacaoLoading, setSearchBoxVariacaoLoading] = useState<boolean>(false)
    //const [descModalCadVariacao, setDescModalCadVariacao] = useState("")

    // ---------- ATRIBUTOS SUBVARIACAO ----------------------------------------------
    const [subVariacaoList, setSubVariacaoList] = useState<VariacaoProduto[]>([])

    // ---------- ATRIBUTOS DELETE ---------------------------------------------------
    const [modalDeleteTitle, setModalDeleteTitle] = useState("")
    const [modalDeleteVisible, setModalDeleteVisible] = useState<boolean>(false)
    const [modalDeleteMessage, setModalDeleteMessage] = useState("")
    const [idGradeDelete, setIdGradeDelete] = useState<number>(0)
    const [loadingDeleteGrade, setLoadingDeleteGrade] = useState<boolean>(false)

    // ---------- ATRIBUTOS GRADE ----------------------------------------------------
    const [cod_barra_grade, setCodBarraGrade] = useState("")
    //const [estoqueGrade, setEstoqueGrade] = useState("")
    const [idSubVariacao, setIdSubVariacao] = useState(0)
    const [idVariacao, setIdVariacao] = useState(0)
    const [gradeList, setGradeList] = useState<GradeProduto[]>([])
    const [loadingGrade, setLoadingGrade] = useState(false)

    // ---------- ATRIBUTOS FOCUS ----------------------------------------------------
    //const [focusPeso, setFocusPeso] = useState(true)
    //const [focusPcusto, setFocusPcusto] = useState(true)
    //const [focusPvenda, setFocusPvenda] = useState(true)
    //const [focusEstoqueMin, setFocusEstoqueMin] = useState(true)

    // ---------- ATRIBUTOS MODAL ----------------------------------------------------
    const [visible_Modal_Grade, setVisible_Modal_Grade] = useState(false)
    const [visible_Modal_Marca_Grupo, setVisible_Modal_Marca_Grupo] = useState(false)
    const [visible_Modal_SubGrupo, setVisible_Modal_SubGrupo] = useState(false)
    const [visible_Modal_UnidMed, setVisible_Modal_UnidMed] = useState(false)
    const [modalType, setModalType] = useState("")
    const [visible_modal_additem, setVisible_modal_additem] = useState(false)

    // ---------- ATRIBUTOS AUDITORIA ------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // ---------- SEARCHBOX ----------------------------------------------------------
    const [visibleSearchBoxGrupo, setVisibleSearchBoxGrupo] = useState<boolean>(false)
    const [visibleSearchBoxSubGrupo, setVisibleSearchBoxSubGrupo] = useState<boolean>(false)
    const [visibleSearchBoxMarca, setVisibleSearchBoxMarca] = useState<boolean>(false)
    const [visibleSearchBoxUnidMed, setVisibleSearchBoxUnidMed] = useState<boolean>(false)
    const [visibleSearchBoxVariacao, setVisibleSearchBoxVariacao] = useState<boolean>(false)
    const [visibleSearchBoxSubVariacao, setVisibleSearchBoxSubVariacao] = useState<boolean>(false)

    // ---------- IMPORTAÇÃO ---------------------------------------------------------
    const [visibleImportacao, setVisibleImportacao] = useState<boolean>(false)

    // ---------- TEMA ---------------------------------------------------------------
    let user = useSelector(state => selectUser(state))


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ || 
    const getAttributes = async () => {

        setLoading(true)

        try {

            const attributes = await ProdutoService.GetAttributes(idProd || idProdDup)


            let newVariacaoList = attributes.data.variacaoProdutos?.filter((item: any) => item.tipo === "V")
            setVariacaoList(newVariacaoList || [])

            newVariacaoList = attributes.data.variacaoProdutos?.filter((item: any) => item.tipo === "S")
            setSubVariacaoList(newVariacaoList || [])

            const gruposList = attributes.data.grupos.filter((item: any) => item.id === attributes.data.produto?.id_grupo?.id)
            if (gruposList && gruposList.length > 0) {
                setIdGrupo(gruposList[0].id)
            }

            const marcaList = attributes.data.marcas.filter((item: any) => item.id === attributes.data.produto?.id_marca?.id)
            if (marcaList && marcaList.length > 0) {
                setIdMarca(marcaList[0].id)
            }

            const sGrupoList = attributes.data.sgrupos.filter((item: any) => item.id === attributes.data.produto?.id_sgrupo?.id)
            if (sGrupoList && sGrupoList.length > 0) {
                setIdSGrupo(sGrupoList[0].id)
            }

            const UnidMedidaList = attributes.data.unidades.filter((item: any) => item.id === attributes.data.produto?.id_unid_medida?.id)
            if (UnidMedidaList && UnidMedidaList.length > 0) {
                setIdUnidMedida(UnidMedidaList[0].id)
            }

            setProdAttributes(attributes.data)
            setGradeAttributes(attributes.data.variacaoProdutos)

            // essa condição é para quando vai atualizar um produto
            if (attributes.data && idProd) {

                setGradeList(attributes.data.grade)

                setImagens(attributes.data.imagens || [])

                setId(attributes.data.produto?.id || 0)
                setDescricao(attributes.data.produto?.descricao || '')
                setDescricaoCopia(attributes.data.produto?.descricao || '')

                setCodBarra(attributes.data.produto?.cod_barra || '')
                setReferencia(attributes.data.produto?.referencia || '')
                setPeso(Funcoes.numberFormat(attributes.data.produto?.peso || 0))
                setNcm(attributes.data.produto?.ncm || '')
                setCest(attributes.data.produto?.cod_cest || '')
                setTributacao(attributes.data.produto?.id_tributacao?.id || 0)
                setTipo(attributes.data.produto?.tipo || 'P')
                setOrigem(attributes.data.produto?.origem_mercadoria?.toString() || '')
                setEstoque(Funcoes.numberFormat(attributes.data.produto?.estoque || 0))
                setEstoqueFisico(Funcoes.numberFormat(attributes.data.produto?.estoque_fisico || 0))
                setEstoqueMinimo(Funcoes.numberFormat(attributes.data.produto?.estoque_minimo || 0))
                setPrecoCusto(Funcoes.numberFormat(attributes.data.produto?.preco_c || 0))
                setPrecoVenda(Funcoes.numberFormat(attributes.data.produto?.preco_v || 0))
                setAtivo(attributes.data.produto?.ativo ? "S" : "N")

                setUserCriador(attributes.data.produto?.name_user_insert || '')
                setUsertAtt(attributes.data.produto?.name_user_last_update || '')

                if (attributes.data.produto?.dt_cadastro) {
                    const dataFormatadaCriacao = moment(attributes.data.produto?.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (attributes.data.produto?.dt_last_update) {
                    const dataFormatadaAtt = moment(attributes.data.produto?.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }
            }

            // essa condição é para quando vai duplicar um produto
            if (attributes.data && idProdDup) {

                setId(0)
                setDescricao(attributes.data.produto?.descricao || '')
                setCodBarra('')
                //setReferencia(attributes.produto?.referencia || '')
                setPeso(Funcoes.numberFormat(attributes.data.produto?.peso || 0))
                setNcm(attributes.data.produto?.ncm || '')
                setCest(attributes.data.produto?.cod_cest || '')
                setTributacao(attributes.data.produto?.id_tributacao?.id || 0)
                setTipo(attributes.data.produto?.tipo || 'P')
                setOrigem(attributes.data.produto?.origem_mercadoria.toString() || '')
                setEstoque(Funcoes.numberFormat(attributes.data.produto?.estoque || 0))
                setEstoqueFisico(Funcoes.numberFormat(attributes.data.produto?.estoque_fisico || 0))
                setEstoqueMinimo(Funcoes.numberFormat(attributes.data.produto?.estoque_minimo || 0))
                setPrecoCusto(Funcoes.numberFormat(attributes.data.produto?.preco_c || 0))
                setPrecoVenda(Funcoes.numberFormat(attributes.data.produto?.preco_v || 0))
                setAtivo(attributes.data.produto?.ativo ? "S" : "N")

            }

            // essa condição é para preencher os campos select de grupos, marcas, subgrupos e unidade de medida
            if (attributes.data) {
                setGrupos([...attributes.data.grupos])
                setMarcas([...attributes.data.marcas])
                setSGrupos([...attributes.data.sgrupos])
                setUnidMedidas([...attributes.data.unidades])
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados ${error}`)

        } finally {
            setLoading(false)
        }
    }

    const updateDadosList = useCallback(async () => {

        try {

            //setLoading(true)
            const attributes = await ProdutoService.GetAttributes(idProd || idProdDup)
            setProdAttributes(attributes.data)
            setGradeAttributes(attributes.data.variacaoProdutos)

            //setLoading(false)

            if (attributes) {
                setGradeList(attributes.data.grade)
                setGrupos([...attributes.data.grupos])
                setMarcas([...attributes.data.marcas])
                setSGrupos([...attributes.data.sgrupos])
                setUnidMedidas([...attributes.data.unidades])
            }

            const focusHandlers: Record<string, () => void> = {
                grupo: () => {
                    boxFocusGrupo()
                    setVisibleSearchBoxGrupo(false)
                },
                marca: () => {
                    boxFocusMarca()
                    setVisibleSearchBoxMarca(false)
                },
                subgrupo: () => {
                    boxFocusSubGrupo()
                    setVisibleSearchBoxSubGrupo(false)
                },
                default: () => {
                    boxFocusUnidMed()
                    setVisibleSearchBoxUnidMed(false)
                },
            };

            (focusHandlers[modalType] || focusHandlers.default)()


        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível atualizar as informações`)


        } finally {

            setVisible_Modal_Marca_Grupo(false)
            setVisible_Modal_SubGrupo(false)
            setVisible_Modal_UnidMed(false)
            setVisible_modal_additem(false)
        }

    }, [idProd, idProdDup, modalType])

    useEffect(() => {
        getAttributes()
        inputFocus()
    }, [])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }
        inputFocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
        searchBoxFocus()
    }

    useEffect(() => {

        if (tabs[0].active) {
            inputFocus()
        } else if (tabs[2].active) {
            inputFocusGrade()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- STATES ATRIBUTOS DADOS BÁSICOS --------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const descricaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescricao(e.target.value)
    }

    const referenciaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setReferencia(e.target.value)
    }

    const filterCodBarraTypeChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {

        const filterMap: { [key: string]: string } = {
            '00': '00',
            '08': '08',
            '12': '12',
            '13': '13',
            '14': '14',
        }

        gerarCodigoBarras(e.target.value)

        const selectedFilter = filterMap[e.target.value]

        if (selectedFilter) {
            setFilterCodBarraType(selectedFilter)

        }
    }

    const codBarraChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCodBarra(e.target.value)
    }

    const gerarNumeroAleatorio = (comprimento: any) => {
        let resultado = ''
        for (let i = 0; i < comprimento; i++) {
            resultado += Math.floor(Math.random() * 10).toString()
        }
        return resultado
    }

    const calcularDigitoVerificacaoEAN13 = (codigo: string) => {
        let soma = 0
        for (let i = 0; i < 12; i++) {
            soma += (i % 2 === 0 ? 1 : 3) * parseInt(codigo.charAt(i), 10)
        }
        return (10 - (soma % 10)) % 10
    }

    const calcularDigitoVerificacaoITF14 = (codigo: string) => {
        let soma = 0
        for (let i = 0; i < 13; i++) {
            soma += (i % 2 === 0 ? 3 : 1) * parseInt(codigo.charAt(i), 10)
        }
        return (10 - (soma % 10)) % 10
    }

    const gerarCodigoBarras = (versaoCodBarras: string) => {
        let codigo = ''

        switch (versaoCodBarras) {
            case '00':
                // UPC-A: 11 dígitos + dígito de verificação
                codigo = gerarNumeroAleatorio(11)
                codigo += calcularDigitoVerificacaoEAN13('0' + codigo)
                break
            case '08':
                // UPC-E: 6 dígitos + dígito de verificação
                const upceData = gerarNumeroAleatorio(6)
                const digitoVerificacaoUPC = calcularDigitoVerificacaoEAN13('0' + upceData.padStart(11, '0'))
                codigo = upceData + digitoVerificacaoUPC
                break
            case '12':
                // EAN-12: 11 dígitos + dígito de verificação (similar ao UPC-A)
                codigo = gerarNumeroAleatorio(11)
                codigo += calcularDigitoVerificacaoEAN13('0' + codigo)
                break
            case '13':
                // EAN-13: 12 dígitos + dígito de verificação
                const eanData = gerarNumeroAleatorio(12)
                const digitoVerificacaoEAN = calcularDigitoVerificacaoEAN13(eanData)
                codigo = eanData + digitoVerificacaoEAN
                break
            case '14':
                // ITF-14: 13 dígitos + dígito de verificação
                const itfData = gerarNumeroAleatorio(13)
                const digitoVerificacaoITF = calcularDigitoVerificacaoITF14(itfData)
                codigo = itfData + digitoVerificacaoITF
                break
            default:
                codigo = '0000000000000' // Default to 13 zeros for EAN-13
        }

        setCodBarra(codigo)
    }

    const ncmChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNcm(e.target.value.replace(/[^0-9]/g, ''))
    }

    const cestChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCest(e.target.value.replace(/[^0-9]/g, ''))
    }

    const hadleChangePeso = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPeso(Funcoes.MaskMoney(e.target.value).replace(".", ","))
    }

    const handleBlurPeso = () => {
        //setFocusPeso(true)


        function formatarPeso(peso: string) {
            // Remove os pontos que separam os milhares e substitui a vírgula pelo ponto
            let pesoFormatado = peso.replace(/\./g, '').replace(',', '.')

            // Converte para número diretamente
            let valorNumerico = parseFloat(pesoFormatado)

            // Agora chamamos a função numberFormat para formatar corretamente com 2 casas decimais
            return Funcoes.numberFormat(valorNumerico, 'decimal', 2, 2)
        }

        setPeso(formatarPeso(peso))

    }

    const handleFocusPeso = () => {
        //setFocusPeso(false)

        searchBoxFocus()
    }

    const ativoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setAtivo(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- GRUPOS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearGrupoSelecionada = useCallback(() => {
        const newGrupoList = [...(prodAttributes?.grupos || [])]
        setGrupos(newGrupoList)
        setIdGrupo(0)

        setVisibleSearchBoxGrupo(false)
        boxFocusGrupo()
    }, [prodAttributes?.grupos])

    const handleFilterGruposClick = useCallback(async (description: string) => {
        if (description === "") {
            const newGrupoList = [...(prodAttributes?.grupos || [])]
            setGrupos(newGrupoList || [])
        } else {
            const newGrupoList = [...(prodAttributes?.grupos || [])].filter((item) =>
                item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            )
            setGrupos(newGrupoList || [])
        }
    }, [prodAttributes?.grupos])

    const handleGruposSelectClick = useCallback((v: Grupo) => {
        if (v) {
            const newGrupoList = [...(prodAttributes?.grupos || [])]
            setGrupos(newGrupoList)
            setIdGrupo(v.id)
        }

        setVisibleSearchBoxGrupo(false)
        boxFocusGrupo()
    }, [prodAttributes?.grupos])

    const updateIdGrupo = useCallback((id: number) => {
        setIdGrupo(id)
    }, [prodAttributes?.grupos])

    const handleDeleteGrupos = async (id: number) => {
        /*
                setVisible(false)
        
                const resp = await GrupoService.Delete(id)
        
                if (resp.error) {
        
                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(`Exclusão não permitida, Grupo já utilizado`)
        
                } else {
        
                    setVisible(true)
                    setMessageType("SUCCESS")
                    setMessage(`Dados excluídos com sucesso`)
        
                    const attributes: ProdAttributes = await ProdutoService.GetAttributes(idProd || idProdDup)
                    setProdAttributes(attributes)
        
                    if (attributes) {
                        setGradeList(attributes.grade)
                        setGrupos([...attributes.grupos] || [])
                        setIdGrupo(0)
                    }
                }
                */
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- SUBGRUPOS ------------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearSubGrupoSelecionada = useCallback(() => {
        const newSGrupoList = [...(prodAttributes?.sgrupos || [])]
        setSGrupos(newSGrupoList)
        setIdSGrupo(0)

        setVisibleSearchBoxSubGrupo(false)
        boxFocusSubGrupo()

    }, [prodAttributes?.sgrupos])

    const handleFilterSubGruposClick = useCallback(async (description: string) => {

        if (description === "") {

            const newSGrupoList = [...(prodAttributes?.sgrupos || [])]
            setSGrupos(newSGrupoList || [])

        } else {

            const newSGrupoList = [...(prodAttributes?.sgrupos || [])].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setSGrupos(newSGrupoList || [])
        }
    }, [prodAttributes?.sgrupos])

    const handleSubGruposSelectClick = useCallback((v: SubGrupo) => {

        if (v) {
            const newSGrupoList = [...(prodAttributes?.sgrupos || [])]
            setSGrupos(newSGrupoList)
            setIdSGrupo(v.id)
        }

        setVisibleSearchBoxSubGrupo(false)
        boxFocusSubGrupo()
    }, [prodAttributes?.sgrupos])

    const updateIdSubGrupo = useCallback((id: number) => {
        setIdSGrupo(id)
    }, [prodAttributes?.sgrupos])

    const handleDeleteSubGrupos = async (id: number) => {
        /*
        setVisible(false)

        const resp = await SubGrupoService.Delete(id)

        if (resp.error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Exclusão não permitida, Subgrupo já utilizado`)

        } else {

            setVisible(true)
            setMessageType("SUCCESS")
            setMessage(`Dados excluídos com sucesso`)

            const attributes: ProdAttributes = await ProdutoService.GetAttributes(idProd || idProdDup)
            setProdAttributes(attributes)

            if (attributes) {
                setGradeList(attributes.grade)
                setSGrupos([...attributes.sgrupos] || [])
                setIdSGrupo(0)
            }
        }
        */
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- MARCAS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearMarcaSelecionada = useCallback(() => {
        const newMarcaList = [...(prodAttributes?.marcas || [])]
        setMarcas(newMarcaList)
        setIdMarca(0)

        setVisibleSearchBoxMarca(false)
        boxFocusMarca()
    }, [prodAttributes?.marcas])

    const handleFilterMarcasClick = useCallback(async (description: string) => {

        if (description === "") {

            const newMarcaList = [...(prodAttributes?.marcas || [])]
            setMarcas(newMarcaList || [])

        } else {

            const newMarcaList = [...(prodAttributes?.marcas || [])].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setMarcas(newMarcaList || [])
        }
    }, [prodAttributes?.marcas])

    const handleMarcasSelectClick = useCallback((v: Marca) => {

        if (v) {
            const newMarcaList = [...(prodAttributes?.marcas || [])]
            setMarcas(newMarcaList)
            setIdMarca(v.id)
        }

        setVisibleSearchBoxMarca(false)
        boxFocusMarca()
    }, [prodAttributes?.marcas])

    const updateIdMarca = useCallback((id: number) => {
        setIdMarca(id)
    }, [prodAttributes?.marcas])

    const handleDeleteMarcas = async (id: number) => {
        /*
        setVisible(false)

        const resp = await MarcaService.Delete(id)

        if (resp.error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Exclusão não permitida, Marcas já utilizado`)

        } else {

            setVisible(true)
            setMessageType("SUCCESS")
            setMessage(`Dados excluídos com sucesso`)

            const attributes: ProdAttributes = await ProdutoService.GetAttributes(idProd || idProdDup)
            setProdAttributes(attributes)

            if (attributes) {
                setGradeList(attributes.grade)
                setMarcas([...attributes.marcas] || [])
                setIdMarca(0)
            }
        }
        */
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- UNID MEDIDAS --------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearUnidMedidaSelecionada = useCallback(() => {
        const newUnidMedidaList = [...(prodAttributes?.unidades || [])]
        setUnidMedidas(newUnidMedidaList)
        setIdUnidMedida(0)

        setVisibleSearchBoxUnidMed(false)
        boxFocusUnidMed()
    }, [prodAttributes?.unidades])

    const handleFilterUnidMedidasClick = useCallback(async (description: string) => {

        if (description === "") {
            const newUnidMedidaList = [...(prodAttributes?.unidades || [])]
            setUnidMedidas(newUnidMedidaList || [])
        } else {
            const newUnidMedidaList = [...(prodAttributes?.unidades || [])].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setUnidMedidas(newUnidMedidaList || [])
        }
    }, [prodAttributes?.unidades])

    const handleUnidMedidasSelectClick = useCallback((v: UnidMedida) => {

        if (v) {
            const newUnidMedidaList = [...(prodAttributes?.unidades || [])]
            setUnidMedidas(newUnidMedidaList)
            setIdUnidMedida(v.id)
        }

        setVisibleSearchBoxUnidMed(false)
        boxFocusUnidMed()
    }, [prodAttributes?.unidades])

    const updateIdUnidade = useCallback((id: number) => {
        setIdUnidMedida(id)
    }, [prodAttributes?.unidades])

    const handleDeleteUnidMedidas = async (id: number) => {
        /*
        setVisible(false)

        const resp = await UnidadeMedidaService.Delete(id)

        if (resp.error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Exclusão não permitida, Unidade de Medida já utilizado`)

        } else {

            setVisible(true)
            setMessageType("SUCCESS")
            setMessage(`Dados excluídos com sucesso`)

            const attributes: ProdAttributes = await ProdutoService.GetAttributes(idProd || idProdDup)
            setProdAttributes(attributes)

            if (attributes) {
                setGradeList(attributes.grade)
                setUnidMedidas([...attributes.unidades] || [])
                setIdUnidMedida(0)
            }
        }
        */
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- STATES ATRIBUTOS CATEGORIZAÇÃO --------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const tributacaoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const inputValue = parseInt(e.target.value)
        setTributacao(inputValue)
    }

    const tipoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        switch (e.target.value) {
            case "P":
                setTipo("P")
                break
            case "S":
                setTipo("S")
                break
            case "M":
                setTipo("M")
                break
        }

    }

    const origemChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setOrigem(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- STATES ATRIBUTOS ESTOQUE --------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const estoqueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEstoque(e.target.value)
    }

    const estoqueFisicoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEstoqueFisico(e.target.value)
    }

    const estoqueMinimoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEstoqueMinimo(Funcoes.MaskMoney(e.target.value).replace(".", ","))
    }

    const handleBlurEstoqueMin = () => {
        //setFocusEstoqueMin(true)

        function formatarEstoque(estoque: string) {
            // Remove os pontos que separam os milhares e substitui a vírgula pelo ponto
            let estoqueFormatado = estoque.replace(/\./g, '').replace(',', '.')

            // Converte para número diretamente
            let valorNumerico = parseFloat(estoqueFormatado)

            // Agora chamamos a função numberFormat para formatar corretamente com 2 casas decimais
            return Funcoes.numberFormat(valorNumerico, 'decimal', 2, 2)
        }

        setEstoqueMinimo(formatarEstoque(estoqueMinimo))
    }

    const handleFocusEstoqueMin = () => {
        //setFocusEstoqueMin(false)

        searchBoxFocus()
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- STATES ATRIBUTOS DADOS FINANCEIROS ----------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const hadleChangePCusto = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPrecoCusto(Funcoes.MaskMoney(e.target.value).replace(".", ","))
    }

    const handleBlurPcusto = () => {
        //setFocusPcusto(true)

        function formatarPreco(preco: string) {
            // Remove os pontos que separam os milhares e substitui a vírgula pelo ponto
            let precoFormatado = preco.replace(/\./g, '').replace(',', '.')

            // Converte para número diretamente
            let valorNumerico = parseFloat(precoFormatado)

            // Agora chamamos a função numberFormat para formatar corretamente com 2 casas decimais
            return Funcoes.numberFormat(valorNumerico, 'decimal', 2, 2)
        }

        setPrecoCusto(formatarPreco(precoCusto))
    }

    const handleFocusPcusto = () => {
        //setFocusPcusto(false)
        searchBoxFocus()
    }

    const hadleChangePVenda = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPrecoVenda(Funcoes.MaskMoney(e.target.value).replace(".", ","))
    }

    const handleBlurPvenda = () => {
        //setFocusPvenda(true)

        function formatarPreco(preco: string) {
            // Remove os pontos que separam os milhares e substitui a vírgula pelo ponto
            let precoFormatado = preco.replace(/\./g, '').replace(',', '.')

            // Converte para número diretamente
            let valorNumerico = parseFloat(precoFormatado)

            // Agora chamamos a função numberFormat para formatar corretamente com 2 casas decimais
            return Funcoes.numberFormat(valorNumerico, 'decimal', 2, 2)
        }

        setPrecoVenda(formatarPreco(precoVenda))
    }

    const handleFocusPvenda = () => {
        //setFocusPvenda(false)
        searchBoxFocus()
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- IMAGENS -------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleSelectImage = () => {
        const inputSelectImage = document.getElementById('inputSelectImage')
        if (inputSelectImage) {
            inputSelectImage.click()
        }

    }

    const handleExcluirImage = async (position: number, image: ProdImages) => {

        setVisible(false)

        let newImagesList = [...imagens]

        if (imagens[position].idProd > 0) {

            newImagesList[position].loading = true
            setImagens(newImagesList)

            try {

                const retApi = await ProdutoService.RemoveImage(image.id.toString())
                newImagesList = [...imagens]
                newImagesList[position].loading = false
                setImagens(newImagesList)

                if (retApi.error) {
                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(retApi.msg || ``)


                } else {

                    newImagesList.splice(position, 1)
                    setImagens(newImagesList)
                }

            } catch (error) {
                newImagesList[position].loading = false
                setImagens(newImagesList)

                setVisible(true)
                setMessageType("DANGER")
                setMessage(`Não foi possível excluir a imagem. Por favor, tente novamente`)

            }
        }
    }

    const handleChangeModalVariacaoVisible = () => {
        //setModalVariacaoVisible(true)
    }

    const handleChangeImage = async (e: React.ChangeEvent<HTMLInputElement>) => {

        setVisible(false)
        setLoadingImage(true)

        if (e.target.files && e.target.files.length > 0) {

            if (imagens.length > 4) {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(`Limite de imagens excedido`)

                    setLoadingImage(false)
                    clearTimeout(timer)
                }, 250)
                return
            }

            let image: ProdImages = {
                id: 0,
                idProd: 0,
                url: ''
            }

            if ((id || 0) > 0) {

                try {

                    const retApi = await ProdutoService.AddImage((id.toString() || ''), e.target.files[0])

                    if (retApi.error) {
                        setVisible(true)
                        setMessageType("DANGER")
                        setMessage(retApi.msg || ``)
                        return

                    }

                    image = {
                        id: retApi.id || 0,
                        idProd: (id || 0),
                        url: URL.createObjectURL(e.target.files[0]),
                        imagem: e.target.files[0],
                    }

                    const newImagesList = [...imagens]
                    newImagesList.push(image)
                    setImagens(newImagesList)

                } catch (error) {

                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`Não foi possível adicionar a imagem`)


                } finally {
                    setLoadingImage(false)
                    e.target.value = ''
                }

            } else {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(`É preciso salvar o cadastro/duplicata do produto antes de adicionar imagens`)
                    setLoadingImage(false)
                    clearTimeout(timer)
                }, 250)

                /*
                image = {
                    id: 0,
                    idProd: (id || 0),
                    url: URL.createObjectURL(e.target.files[0]),
                    imagem: e.target.files[0],
                }
                */

            }

            e.target.value = ''
        }
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- GRADE ---------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleCodBarraGradeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCodBarraGrade(e.target.value)
    }

    const handleChangeEstoqueGrade = (e: React.ChangeEvent<HTMLInputElement>) => {
        //setEstoqueGrade(e.target.value)
    }

    const handleSaveGrade = useCallback(async (codBarraGrade: string, idVariacaoGrade: number, idSubVariacaoGrade: number, estoqueSaldoGrade: string) => {

        setVisible(false)
        setLoadingGrade(true)

        if (codBarraGrade === "") {

            const timer = setTimeout(() => {
                setVisible(true)
                setMessageType("DANGER")
                setMessage(`Cód. Barras/Referência não informada`)
                setLoadingGrade(false)
                clearTimeout(timer)
            }, 250)
            return
        }

        if (idVariacaoGrade === 0) {

            const timer = setTimeout(() => {
                setVisible(true)
                setMessageType("DANGER")
                setMessage(`Variação não informada`)
                setLoadingGrade(false)
                clearTimeout(timer)
            }, 250)
            return
        }

        try {

            const grade: GradeProduto = {
                codBarraRef: codBarraGrade,
                idProduto: id,
                variacao: {
                    id: idVariacaoGrade,
                    description: '',
                    tipo: 'V'
                },
                saldoEstoque: parseInt(estoqueSaldoGrade) || 0,
                subVariacao: {
                    id: idSubVariacaoGrade,
                    description: '',
                    tipo: 'S'
                }
            }

            const retApi = await ProdutoService.SaveGrade(grade)

            if (retApi.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(retApi.msg || ``)

            } else {

                const updatedGradeList = await ProdutoService.ListarGrade(id)
                const grade = await ProdutoService.GetAttributesGrade()
                setGradeList(updatedGradeList.data)
                setGradeAttributes(grade.data)

                setVisible(true)
                setMessageType("SUCCESS")
                setMessage(`Dados gravados com sucesso`)

                let newVariacaoList = grade.data.filter((item: any) => item.tipo === "V")
                setVariacaoList(newVariacaoList || [])

                newVariacaoList = grade.data.filter((item: any) => item.tipo === "S")
                setSubVariacaoList(newVariacaoList || [])

                setVisible_Modal_Grade(false)

                //setLoadingGrade(false)
                //setIdVariacao(0)
                //setIdSubVariacao(0)
                //setCodBarraGrade("")
                //setEstoqueGrade("")
                /*
                const intervalo = setTimeout(() => {
                    setVisible(false)
                    setMessage(``)
                    clearTimeout(intervalo)
                }, 2000)
                */
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(``)

        } finally {
            setLoadingGrade(false)
        }

    }, [id])

    const handleConfirmDeleteGrade = useCallback(async (motivo: string, senha: string) => {

        setVisible(false)
        setLoadingDeleteGrade(true)

        try {

            const retAPI = await ProdutoService.DeleteGrade(idGradeDelete, motivo, senha)

            if (retAPI.error) {
                setVisible(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || ``)

                return
            }

            const updatedGradeList = await ProdutoService.ListarGrade(id)
            setGradeList(updatedGradeList.data)

            setVisible(true)
            setMessageType("SUCCESS")
            setMessage(`Grade excluída com sucesso`)

            setModalDeleteVisible(false)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Um erro inesperado ocorreu ao excluir a grade. Por favor, tente novamente`)


        } finally {
            setLoadingDeleteGrade(false)
        }

    }, [idGradeDelete, id])

    const handleDeleteGrade = (idGrade: number, position: number) => {
        setIdGradeDelete(idGrade)
        setModalDeleteVisible(true)
        setModalDeleteMessage(`Deseja excluir a grade ${position + 1}?`)
        setModalDeleteTitle("Excluir grade")
    }

    const pesquisarGrade = async () => {

        handleInputFocusGrade()

        setVisible(false)
        setLoading(true)

        try {

            let relatorio = {
                id_produto: id,
                id_variacao: idVariacao,
                id_sub_variacao: idSubVariacao,
                referencia: cod_barra_grade
            }

            const gradeList = await ProdutoService.FilterGrade(relatorio)
            setGradeList(gradeList.data)

        } catch (error) {
            setGradeList([])

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Um erro inesperado ocorreu ao pesquisar a grade. Por favor, tente novamente`)

        } finally {

            inputFocusGrade()
            setLoading(false)
        }

    }

    const limparCamposGrade = () => {

        setCodBarraGrade("")
        setIdVariacao(0)
        setIdSubVariacao(0)

        handleInputFocusGrade()
        inputFocusGrade()
    }

    const handleInputFocusGrade = () => {
        setVisibleSearchBoxSubVariacao(false)
        setVisibleSearchBoxVariacao(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- VARIAÇÃO ------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearVariacaoSelecionada = useCallback(() => {
        const newVariacaoList = [...gradeAttributes?.filter(item => item.tipo === "V") || []]
        setVariacaoList(newVariacaoList)
        setIdVariacao(0)

        setVisibleSearchBoxVariacao(false)
    }, [gradeAttributes])

    const handleFilterVariacaoClick = useCallback(async (description: string) => {

        if (description === "") {

            const newVariacaoList = [...gradeAttributes?.filter(item => item.tipo === "V") || []]
            setVariacaoList(newVariacaoList || [])

        } else {

            const newVariacaoList = [...gradeAttributes || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()) && item.tipo === "V"
            })
            setVariacaoList(newVariacaoList || [])

        }
    }, [gradeAttributes])

    const handleVariacaoSelectClick = useCallback((v: VariacaoProduto) => {

        if (v) {
            const newVariacaoList = [...gradeAttributes?.filter(item => item.tipo === "V") || []]
            setVariacaoList(newVariacaoList)
            setIdVariacao(v.id)
        }
        setVisibleSearchBoxVariacao(false)

    }, [gradeAttributes])

    const clickSearchBoxVariacao = useCallback(() => {
        setVisibleSearchBoxVariacao((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha o SubVariacao ao abrir Variacao e foca no input
                setVisibleSearchBoxSubVariacao(false)
                inputFocusVariacao()
            }
            return newState
        })
    }, [])

    const inputFocusVariacao = () => {
        let inputSearch = document.getElementById(`inputSearchBox-varia`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    const handleAddVariacao = () => {
        //setDescModalCadVariacao(prodAttributes?.descVariacao ? prodAttributes.descVariacao : "Variacao")
        //setTipoVariacao("V")
        //setModalVariacaoVisible(true)
    }

    const handleDeleteVariacao = async (id: number) => {
        /*
        setVisible(false)

        setSearchBoxVariacaoLoading(true)

        const retAPI = await ProdutoService.DeleteVariacao(id)

        if (retAPI.error) {

            let newList = variacaoList.filter((item: VariacaoProduto) => item.tipo === "V")
            setVariacaoList(newList)

            setSearchBoxVariacaoLoading(false)
            setVisible(true)
            setMessageType("DANGER")
            setMessage(retAPI.msg || ``)
            
            return
        }

        let newVariacaoList = retAPI.data.filter((item: VariacaoProduto) => item.tipo === "V")
        setVariacaoList(newVariacaoList)

        newVariacaoList = retAPI.data.filter((item: VariacaoProduto) => item.tipo === "S")
        setSubVariacaoList(newVariacaoList)

        setSearchBoxVariacaoLoading(false)
        setIdVariacao(0)
        */

    }

    const handleSaveVariacao = async (desc: string) => {
        /*
        setVisible(false)

        if (!desc) {
            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Descrição não informada`)
            
            return
        }

        if (!tipoVariacao) {
            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Tipo da variação não informado`)
            
            return
        }

        //setLoadingSaveVariacao(true)
        const retApi = await ProdutoService.AddVariacao(desc, tipoVariacao)

        const attributes: ProdAttributes = await ProdutoService.GetAttributes(idProd || idProdDup)
        setProdAttributes(attributes)

        if (retApi.error) {
            setVisible(true)
            setMessageType("DANGER")
            setMessage(retApi.msg || ``)
            

            return

        } else {

            setVisible(true)
            setMessageType("SUCCESS")
            setMessage(`Dados gravados com sucesso`)
            

            if (retApi.data) {

                let newVariacaoList = retApi.data.filter((item: VariacaoProduto) => item.tipo === "V")
                setVariacaoList(newVariacaoList)

                newVariacaoList = retApi.data.filter((item: VariacaoProduto) => item.tipo === "S")
                setSubVariacaoList(newVariacaoList)
            }

            //setLoadingSaveVariacao(false)
            //setModalVariacaoVisible(false)

        }
        */
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- SUBVARIAÇÃO ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearSubVariacaoSelecionada = useCallback(() => {
        const newSubVariacaoList = [...gradeAttributes?.filter(item => item.tipo === "S") || []]
        setSubVariacaoList(newSubVariacaoList)
        setIdSubVariacao(0)

        setVisibleSearchBoxSubVariacao(false)
    }, [gradeAttributes])

    const handleFilterSubVariacaoClick = useCallback(async (description: string) => {

        if (description === "") {

            const newSubVariacaoList = [...gradeAttributes?.filter(item => item.tipo === "S") || []]
            setSubVariacaoList(newSubVariacaoList || [])

        } else {

            const newSubVariacaoList = [...gradeAttributes || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()) && item.tipo === "S"
            })

            setSubVariacaoList(newSubVariacaoList || [])
        }

    }, [gradeAttributes])

    const handleSubVariacaoSelectClick = useCallback((v: VariacaoProduto) => {

        if (v) {
            const newSubVariacaoList = [...gradeAttributes?.filter(item => item.tipo === "S") || []]
            setSubVariacaoList(newSubVariacaoList)
            setIdSubVariacao(v.id)
        }
        setVisibleSearchBoxSubVariacao(false)

    }, [gradeAttributes])

    const clickSearchBoxSubVariacao = useCallback(() => {
        setVisibleSearchBoxSubVariacao((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha o Variacao ao abrir SubVariacao e foca no input
                setVisibleSearchBoxVariacao(false)
                inputFocusSubVariacao()
            }
            return newState
        })
    }, [])

    const inputFocusSubVariacao = () => {
        let inputSearch = document.getElementById(`inputSearchBox-subVaria`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    const handleAddSubVariacao = () => {
        //setDescModalCadVariacao(prodAttributes?.descSubVariacao ? prodAttributes.descSubVariacao : "Sub Variacao")
        //setTipoVariacao("S")
        //setModalVariacaoVisible(true)
    }

    const handleDeleteSubVariacao = async (id: number) => {
        /*
        setVisible(false)
        setSearchBoxVariacaoLoading(true)

        const retAPI = await ProdutoService.DeleteVariacao(id)

        if (retAPI.error) {

            let newList = variacaoList.filter((item: VariacaoProduto) => item.tipo === "S")
            setSubVariacaoList(newList)

            setSearchBoxVariacaoLoading(false)
            setVisible(true)
            setMessageType("DANGER")
            setMessage(retAPI.msg || ``)
            
            return
        }

        let newVariacaoList = retAPI.data.filter((item: VariacaoProduto) => item.tipo === "V")
        setVariacaoList(newVariacaoList)

        newVariacaoList = retAPI.data.filter((item: VariacaoProduto) => item.tipo === "S")
        setSubVariacaoList(newVariacaoList)

        setSearchBoxVariacaoLoading(false)
        setIdSubVariacao(0)
        */
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- PRODUTO -------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const NovoProduto = () => {

        //const newGrupoList = [...prodAttributes?.grupos || []]
        //setGrupos(newGrupoList)
        //const newMarcaList = [...prodAttributes?.marcas || []]
        //setMarcas(newMarcaList)
        //const newSubGrupoList = [...prodAttributes?.sgrupos || []]
        //setSGrupos(newSubGrupoList)
        //const newUnidMedidaList = [...prodAttributes?.unidades || []]
        //setUnidMedidas(newUnidMedidaList)

        if (!(parseInt(idProdDup || '') > 0)) {
            setDescricao('')
        }

        setId(0)
        setReferencia('')
        setFilterCodBarraType('00')
        setCodBarra('')
        setNcm('')
        setCest('')
        setPeso('0,00')
        setAtivo("S")

        setIdGrupo(0)
        setIdSGrupo(0)
        setIdMarca(0)
        setIdUnidMedida(0)
        setTributacao(0)
        setTipo('P')
        setOrigem('')
        setEstoque('0,00')
        setEstoqueFisico('0,00')
        setEstoqueMinimo('0,00')
        setPrecoCusto('0,00')
        setPrecoVenda('0,00')

        setImagens([])
        setGradeList([])

        setDtCriador('')
        setUserCriador('')
        setDtAtt('')
        setUsertAtt('')

        searchBoxFocus()

        if (messageType === 'DANGER') {
            setVisible(false)
        }
        redefinirCampos()
        inputFocus()
    }

    const handleSaveProducts = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setLoading(true)
        searchBoxFocus()

        try {

            let produto: any = {
                id: id,
                descricao: descricao,
                codBarra: codBarra,
                referencia: referencia,
                peso: parseFloat(peso.replaceAll(".", "").replace(",", ".")),
                ncm: ncm,
                cest: cest,
                grupo: { id: idGrupo.toString(), descricao: '' },
                sgrupo: { id: idSGrupo.toString(), descricao: '' },
                marca: { id: idMarca.toString(), descricao: '' },
                unid: { id: idUnidMedida.toString(), fator: 0, descricao: '' },
                gTributacao: { id: tributacao },
                tipo: tipo || 'P',
                origem: origem || '0',
                estoque: parseFloat(estoque.replaceAll(".", "").replace(",", ".")),
                estoqueFisico: parseFloat(estoqueFisico.replaceAll(".", "").replace(",", ".")),
                estoqueMinimo: parseFloat(estoqueMinimo.replaceAll(".", "").replace(",", ".")),
                pCusto: parseFloat(precoCusto.replaceAll(".", "").replace(",", ".")),
                pVenda: parseFloat(precoVenda.replaceAll(".", "").replace(",", ".")),
                ativo: ativo === 'S',
            }

            const imageList = imagens.filter(item => item.idProd === 0)
            const resp = await ProdutoService.Save(produto, imageList)

            if (resp.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || ``)
                //checkDadosObrigatorios(resp.field || '')

            } else {

                /*
                if (resp.data) {

                    if (resp.data.error === '1') {

                        setVisible(true)
                        setMessageType("DANGER")
                        setMessage(resp.data.msg)
                    }

                    /*
                    const newImageList = await resp.data.map((item: any) => {
                        return {
                            id: item.id,
                            idProd: item.idProd,
                            url: item.url,
                        }
                    })
                    
                    //setImagens(newImageList)
                }
                */

                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)

                setMessage(id > 0 ? `Dados do produto atualizados com sucesso` : resp.msg || ``)

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setDescricaoCopia(resp.data.prod.descricao)
                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')

                redefinirCampos()

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? `Não foi possível atualizar o produto. Por favor, tente novamente` : `Não foi possível salvar o produto. Por favor, tente novamente`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                inputFocus()
                clearTimeout(timer)
            }, 1200)
        }
    }

    const checkDadosObrigatorios = (field: string): boolean => {

        if (descricao.trim() === '') {

            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (idUnidMedida === 0) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (tributacao === 0) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (parseInt(precoVenda) <= 0) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        return false
    }

    const redefinirCampos = async () => {

        let fieldsM: CampoObrigatorio[] = [
            { campo: 'descricao', erro: false }, // Posição 0 do Array.
            { campo: 'unid', erro: false }, // Posição 1 do Array
            { campo: 'gtrib', erro: false },   // Posição 2 do Array.    
            { campo: 'pvenda', erro: false },   // Posição 3 do Array. 

        ]

        setCamposObrigatorios(fieldsM)

    }

    const inputFocus = () => {
        const inputElement = document.getElementById("descricao")
        inputElement?.focus()
    }

    const inputFocusGrade = () => {
        const inputElement = document.getElementById("cod_barras_pesquisa")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- MODALS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const abrirModalMarca = useCallback(() => {
        setModalType('marca')
        setVisible_Modal_Marca_Grupo(true)
        setVisible_modal_additem(true)
    }, [])

    const abrirModalGrupo = useCallback(() => {
        setModalType('grupo')
        setVisible_Modal_Marca_Grupo(true)
        setVisible_modal_additem(true)
    }, [])

    const abrirModalSubGrupo = useCallback(() => {
        setModalType('subgrupo')
        setVisible_Modal_SubGrupo(true)
        setVisible_modal_additem(true)
    }, [])

    const abrirModalUnidMedida = useCallback(() => {
        setModalType('unidmedida')
        setVisible_Modal_UnidMed(true)
        setVisible_modal_additem(true)
    }, [])

    const abrirModalCriarGrade = useCallback(() => {
        setVisible_Modal_Grade(true)
    }, [])

    const fecharModalMarcaGrupo = useCallback(() => {
        setVisible_Modal_Marca_Grupo(false)
        setVisible_modal_additem(false)

        if (modalType === 'grupo') {

            boxFocusGrupo()
            inputFocusGrupo()

        } else if (modalType === 'marca') {

            boxFocusMarca()
            inputFocusMarca()
        }
    }, [modalType])

    const fecharModalSubGrupo = useCallback(() => {
        setVisible_Modal_SubGrupo(false)
        setVisible_modal_additem(false)
        boxFocusSubGrupo()
        inputFocusSubGrupo()
    }, [])

    const fecharModalUnidMedida = useCallback(() => {
        setVisible_Modal_UnidMed(false)
        setVisible_modal_additem(false)
        boxFocusUnidMed()
        inputFocusUnidMedida()

    }, [])

    const fecharModalCriarGrade = useCallback(async () => {

        setVisible_Modal_Grade(false)
        setVisible(false)
        inputFocusGrade()

        const grade = await ProdutoService.GetAttributesGrade()
        setGradeAttributes(grade.data)

        let newVariacaoList = grade.data.filter((item: any) => item.tipo === "V")
        setVariacaoList(newVariacaoList || [])

        newVariacaoList = grade.data.filter((item: any) => item.tipo === "S")
        setSubVariacaoList(newVariacaoList || [])

    }, [])

    const fecharModalExclusao = useCallback(() => {

        if (messageType == 'SUCCESS') {
            setModalDeleteVisible(false)
        }

        setVisible(false)
    }, [messageType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setModalDeleteVisible(false)
        setVisible(false)
    }, [])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 1 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        descProd: useRef(null),
        referencia: useRef(null),
        versaoCodBarra: useRef(null),
        codBarra: useRef(null),
        ncm: useRef(null),
        codCest: useRef(null),
        peso: useRef(null),
        ativo: useRef(null),
        grupo: useRef(null),
        subGrupo: useRef(null),
        marca: useRef(null),
        unidMed: useRef(null),
        trib: useRef(null),
        tipoProd: useRef(null),
        origem: useRef(null),
        estoque: useRef(null),
        estoqueFis: useRef(null),
        estoqueMin: useRef(null),
        precoCusto: useRef(null),
        precoVenda: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[0].active) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            searchBoxFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
             do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            if (nextIndex === 8) {
                setVisibleSearchBoxGrupo(true)
                inputFocusGrupo()
            }

            if (nextIndex === 9) {
                setVisibleSearchBoxSubGrupo(true)
                inputFocusSubGrupo()
            }

            if (nextIndex === 10) {
                setVisibleSearchBoxMarca(true)
                inputFocusMarca()
            }

            if (nextIndex === 11) {
                setVisibleSearchBoxUnidMed(true)
                inputFocusUnidMedida()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && tabs[0].active) {

                event.preventDefault()

                const inputSearchGrupo = document.getElementById('inputSearchBox-grupo') as HTMLInputElement
                const inputSearchSubGrupo = document.getElementById('inputSearchBox-subgrupo') as HTMLInputElement
                const inputSearchMarca = document.getElementById('inputSearchBox-marca') as HTMLInputElement
                const inputSearchUnidMed = document.getElementById('inputSearchBox-unidMed') as HTMLInputElement

                if (document.activeElement === inputSearchGrupo) {
                    clickSearchBoxSubGrupo()
                    setVisibleSearchBoxGrupo(false)

                } else if (document.activeElement === inputSearchSubGrupo) {
                    clickSearchBoxMarca()
                    setVisibleSearchBoxSubGrupo(false)

                } else if (document.activeElement === inputSearchMarca) {
                    clickSearchBoxUnidMed()
                    setVisibleSearchBoxMarca(false)

                } else if (document.activeElement === inputSearchUnidMed) {
                    inputsRefs['trib'].current?.focus()
                    setVisibleSearchBoxUnidMed(false)
                }
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [tabs])

    const searchBoxFocus = () => {
        setVisibleSearchBoxGrupo(false)
        setVisibleSearchBoxMarca(false)
        setVisibleSearchBoxSubGrupo(false)
        setVisibleSearchBoxUnidMed(false)
    }

    // GRUPO ---------------------------------------------------
    const boxFocusGrupo = () => {
        // Move o foco para o input correspondente à chave 'grupo'.
        inputsRefs['grupo'].current?.focus()
    }

    const clickSearchBoxGrupo = useCallback(() => {
        setVisibleSearchBoxGrupo((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha outros componentes e foca no Grupo
                setVisibleSearchBoxSubGrupo(false)
                setVisibleSearchBoxMarca(false)
                setVisibleSearchBoxUnidMed(false)
                inputFocusGrupo()
            }
            return newState
        })

        boxFocusGrupo() // Sempre executa ao clicar
    }, [])

    const inputFocusGrupo = () => {
        let inputSearch = document.getElementById(`inputSearchBox-grupo`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // SUBGRUPO --------------------------------------------------
    const boxFocusSubGrupo = () => {
        // Move o foco para o input correspondente à chave 'subGrupo'.
        inputsRefs['subGrupo'].current?.focus()
    }

    const clickSearchBoxSubGrupo = useCallback(() => {
        setVisibleSearchBoxSubGrupo((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha outros search boxes e foca no SubGrupo
                setVisibleSearchBoxGrupo(false)
                setVisibleSearchBoxMarca(false)
                setVisibleSearchBoxUnidMed(false)
                inputFocusSubGrupo()
            }
            return newState
        })

        boxFocusSubGrupo() // Sempre executa ao clicar
    }, [])

    const inputFocusSubGrupo = () => {
        let inputSearch = document.getElementById(`inputSearchBox-subgrupo`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // MARCA -----------------------------------------------------
    const boxFocusMarca = () => {
        // Move o foco para o input correspondente à chave 'marca'.
        inputsRefs['marca'].current?.focus()
    }

    const clickSearchBoxMarca = useCallback(() => {
        setVisibleSearchBoxMarca((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha outros search boxes e foca na Marca
                setVisibleSearchBoxGrupo(false)
                setVisibleSearchBoxSubGrupo(false)
                setVisibleSearchBoxUnidMed(false)
                inputFocusMarca()
            }
            return newState
        })

        boxFocusMarca() // Sempre executa ao clicar
    }, [])

    const inputFocusMarca = () => {
        let inputSearch = document.getElementById(`inputSearchBox-marca`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // UNIDMEDIDA -------------------------------------------------
    const boxFocusUnidMed = () => {
        // Move o foco para o input correspondente à chave 'unidMed'.
        inputsRefs['unidMed'].current?.focus()
    }

    const clickSearchBoxUnidMed = useCallback(() => {
        setVisibleSearchBoxUnidMed((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no UnidMed
                setVisibleSearchBoxGrupo(false)
                setVisibleSearchBoxSubGrupo(false)
                setVisibleSearchBoxMarca(false)
                inputFocusUnidMedida()
            }
            return newState
        })

        boxFocusUnidMed() // Sempre executa ao clicar
    }, [])

    const inputFocusUnidMedida = () => {
        let inputSearch = document.getElementById(`inputSearchBox-unidMed`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 3 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||    
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab' && !(tabs[0].active)) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- IMPORTAÇÃO ----------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const abrirModalImportacao = () => {
        setVisibleImportacao(true)

        if (messageType === 'DANGER') {
            setVisible(false)
        }
    }

    const fecharModalImportacao = useCallback(() => {
        setVisibleImportacao(false)
        setVisible(false)

        if (tabs[0].active) {
            inputFocus()
        } else if (tabs[2].active) {
            inputFocusGrade()
        }
    }, [tabs])

    const formFields = [
        { pl: "Descrição", bd: "descricao" },
        { pl: "Referência", bd: "referencia" },
        { pl: "Cód. de Barras", bd: "cod_barra" },
        { pl: "NCM", bd: "ncm" },
        { pl: "Cód. Cest", bd: "cod_cest" },
        { pl: "Peso (KG)", bd: "peso" },
        { pl: "Grupo", bd: "id_grupo" },
        { pl: "SubGrupo", bd: "id_sgrupo" },
        { pl: "Marca", bd: "id_marca" },
        { pl: "Unid. Medida", bd: "id_unid_medida" },
        { pl: "Origem", bd: "origem_mercadoria" },
        { pl: "Estoque Mínimo", bd: "estoque_minimo" },
        { pl: "Estoque Físico", bd: "estoque_fisico" },
        { pl: "Preço de Custo", bd: "preco_c" },
        { pl: "Preço de Venda", bd: "preco_v" },

    ]

    const importarDados = useCallback(async (planilha: any, mapa: any) => {

        setVisible(false)
        setLoading(true)

        try {

            const dados = await ProdutoService.ProdutoImportacao(planilha, mapa)

            if (dados.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(dados.msg || ``)

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setMessage(`Dados importados com sucesso`)

                setVisibleImportacao(false)
                inputFocus()
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível concluir a importação. Por favor, tente novamente`)

        } finally {
            setLoading(false)
        }

    }, [])

    const btNovoVisible = parseInt(idProd || '') > 0 ? 'invisible hidden' : 'visible'
    const ativoEdit = parseInt(idProd || '') > 0 ? false : true

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div id='div-body' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`grid grid-cols-12`}>

                            <div className={`col-span-10 xl:col-span-11 h-[50px] w-full flex items-center my-3 px-2`}>
                                <FcNook className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" />
                                <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all`}>{parseInt(idProd || '') || id > 0 ? `Editar - Produto - ${descricaoCopia}` : parseInt(idProdDup || '') > 0 ? `Duplicar - Produto` : `Cadastro - Produto`}</span>
                            </div>

                            <div className={`col-span-2 xl:col-span-1 h-[50px] w-full flex items-center my-3 px-2`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} data-tooltip-id={'tooltip-btn-dados'} id={'btn-dados'} onClick={abrirModalImportacao}>
                                    <FaFileDownload size="25px" />
                                    <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-dados'} anchorSelect={'#btn-dados'} positionStrategy="fixed" place='left' >
                                        <span>Importar Dados</span>
                                    </Tooltip>
                                </button>
                            </div>

                        </div>

                        <div className={`w-full h-full relative`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (
                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                }`}>
                                            <div tabIndex={-1} className={`flex items-center`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}
                            </div>

                            { /* Dados Principais */}
                            <div className={`${tabs[0].active ? 'block' : 'hidden'} relative`}>

                                <div className={`flex flex-col sm:flex-row`}>

                                    <div className={`w-full grid gap-6 grid-cols-12 p-4`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <div className={`flex flex-row `}>
                                                <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300  mr-2`}>Dados do Produto</span>
                                                <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                                <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                    <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                                </Tooltip>
                                            </div>

                                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                        </div>

                                        <div className={`relative col-span-12`}>

                                            <div className={`${barraVermelhoAzul} ${descricao !== '' ? bgBlue : bgRed}`} />
                                            <input ref={inputsRefs.descProd} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'descProd')} id="descricao" className={`${classInput} ${classInputDark} ${descricao === '' ? focusRed : ''}`} type='text' inputMode='text' maxLength={155} placeholder=" " autoComplete='off' value={descricao} onFocus={searchBoxFocus} onChange={descricaoChange} />
                                            <label htmlFor="descricao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${descricao === '' ? focusLabelRed : ''}`}>Descrição</label>
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-6`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.referencia} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'referencia')} id="referencia" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={40} placeholder=" " autoComplete='off' value={referencia} onFocus={searchBoxFocus} onChange={referenciaChange} />
                                            <label htmlFor="referencia" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Referência</label>
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-6 2xl:col-span-3`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <select ref={inputsRefs.versaoCodBarra} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'versaoCodBarra')} id='versaoCodBarra' className={`${classInput} ${classInputDark}`} value={filterCodBarraType} disabled={loading} onFocus={searchBoxFocus} onChange={filterCodBarraTypeChange} >
                                                <option value="00">00</option>
                                                <option value="08">08</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                            </select>
                                            <label htmlFor="versaoCodBarra" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Versão Cód.Barras</label>
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-6 2xl:col-span-3`}>

                                            <div className={`${barraVermelhoAzul} ${codBarra != '' ? bgBlue : bgRed}`} />
                                            <input ref={inputsRefs.codBarra} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'codBarra')} id="cod_barra" className={`${classInput} ${classInputDark} ${codBarra != '' ? '' : focusRed}`} type='text' inputMode='text' maxLength={40} placeholder=" " autoComplete='off' value={codBarra} onFocus={searchBoxFocus} onChange={codBarraChange} />
                                            <label htmlFor="cod_barra" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${codBarra != '' ? '' : focusLabelRed}`}>Cód. de Barras</label>
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-6 xl:col-span-3`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.ncm} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'ncm')} id="ncm" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' maxLength={8} placeholder=" " autoComplete='off' value={ncm} onFocus={searchBoxFocus} onChange={ncmChange} />
                                            <label htmlFor="ncm" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>NCM</label>
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-6 xl:col-span-3`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.codCest} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'codCest')} id="cod_cest" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' maxLength={7} placeholder=" " autoComplete='off' value={cest} onFocus={searchBoxFocus} onChange={cestChange} />
                                            <label htmlFor="cod_cest" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Cód. Cest</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-6 xl:col-span-3`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.peso} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'peso')} id="peso" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={peso} onBlur={handleBlurPeso} onFocus={searchBoxFocus} onChange={hadleChangePeso} />
                                            <label htmlFor="peso" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Peso (KG)</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-6 xl:col-span-3`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <select ref={inputsRefs.ativo} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'ativo')} id="ativo" disabled={ativoEdit} className={`${classInput} ${classInputDark} ${parseInt(idProd || '0') > 0 ? `cursor-pointer` : `cursor-not-allowed`}`} value={ativo} onFocus={searchBoxFocus} onChange={ativoChange}>
                                                <option value="S">Sim</option>
                                                <option value="N">Não</option>
                                            </select>
                                            <label htmlFor="ativo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Ativo</label>
                                        </div>

                                    </div>

                                    <div className={`w-full grid gap-6 grid-cols-12 p-4 sm:h-[50px]`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300`}>Categorização</span>
                                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-6 xl:col-span-4`}>

                                            <div ref={inputsRefs['grupo']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'grupo')} />

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <SearchBox
                                                dataList={grupos}
                                                idRegistro={idGrupo || undefined}
                                                label='Grupo'
                                                componentId='grupo'
                                                visibleAddItem={visible_modal_additem}
                                                visibleTAB={visibleSearchBoxGrupo}
                                                setDataClick={handleGruposSelectClick}
                                                clearDataClick={handleClearGrupoSelecionada}
                                                filterDataClick={handleFilterGruposClick}
                                                additem={abrirModalGrupo}
                                                clicado={clickSearchBoxGrupo}
                                            />
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-6 xl:col-span-4`}>

                                            <div ref={inputsRefs['subGrupo']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'subGrupo')} />

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <SearchBox
                                                dataList={sGrupos}
                                                idRegistro={idSGrupo || undefined}
                                                label='SubGrupo'
                                                componentId='subgrupo'
                                                visibleAddItem={visible_modal_additem}
                                                visibleTAB={visibleSearchBoxSubGrupo}
                                                setDataClick={handleSubGruposSelectClick}
                                                clearDataClick={handleClearSubGrupoSelecionada}
                                                filterDataClick={handleFilterSubGruposClick}
                                                additem={abrirModalSubGrupo}
                                                clicado={clickSearchBoxSubGrupo}
                                            />
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-6 xl:col-span-4`}>

                                            <div ref={inputsRefs['marca']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'marca')} />

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <SearchBox
                                                dataList={marcas}
                                                idRegistro={idMarca || undefined}
                                                label='Marca'
                                                componentId='marca'
                                                visibleAddItem={visible_modal_additem}
                                                visibleTAB={visibleSearchBoxMarca}
                                                setDataClick={handleMarcasSelectClick}
                                                clearDataClick={handleClearMarcaSelecionada}
                                                filterDataClick={handleFilterMarcasClick}
                                                additem={abrirModalMarca}
                                                clicado={clickSearchBoxMarca}
                                            />
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-6 xl:col-span-4`}>

                                            <div ref={inputsRefs['unidMed']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'unidMed')} />

                                            <div className={`${barraVermelhoAzul} ${idUnidMedida > 0 ? bgBlue : bgRed}`} />
                                            <SearchBox
                                                dataList={unidMedidas}
                                                idRegistro={idUnidMedida || undefined}
                                                label='Unid. Medida'
                                                componentId='unidMed'
                                                visibleAddItem={visible_modal_additem}
                                                visibleTAB={visibleSearchBoxUnidMed}
                                                borda={true}
                                                setDataClick={handleUnidMedidasSelectClick}
                                                clearDataClick={handleClearUnidMedidaSelecionada}
                                                filterDataClick={handleFilterUnidMedidasClick}
                                                additem={abrirModalUnidMedida}
                                                clicado={clickSearchBoxUnidMed}
                                            />
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-6 xl:col-span-4`}>

                                            <div className={`${barraVermelhoAzul} ${tributacao > 0 ? bgBlue : bgRed}`} />

                                            <select ref={inputsRefs.trib} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'trib')} id="id_tributacao" className={`${classInput} ${classInputDark} ${tributacao > 0 ? '' : focusRed}`} value={tributacao} onFocus={searchBoxFocus} onChange={tributacaoChange}>
                                                <option value="" />
                                                {prodAttributes?.gTrib.map((gtrib) => { return <option key={gtrib.id} value={gtrib.id}>{gtrib.descricao}</option> })}
                                            </select>

                                            <label htmlFor="id_tributacao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${tributacao > 0 ? '' : focusLabelRed}`}>Tributação</label>

                                            {/*
                                            <button className={`absolute top-0 right-0 text-center mt-2.5`} >
                                                <IoHelpCircleOutline className={`dark:text-slate-200 mr-2`} size="20px" />
                                            </button>
                                            */}

                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-6 xl:col-span-4`}>

                                            <div className={`${barraVermelhoAzul} ${tipo.toString() != '' ? bgBlue : bgRed}`} />

                                            <select ref={inputsRefs.tipoProd} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'tipoProd')} id="tipo" className={`${classInput} ${classInputDark} ${tipo.toString() == '' ? focusRed : ''}`} value={tipo.toString()} onFocus={searchBoxFocus} onChange={tipoChange}>
                                                {TiposProdutos.map((item: any) => { return <option key={item.sigla} value={item.sigla}>{item.descricao}</option> })}
                                            </select>

                                            <label htmlFor="tipo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${tipo.toString() == '' ? focusLabelRed : ''}`}>Tipo</label>
                                        </div>

                                        <div className={`relative col-span-12`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />

                                            <select ref={inputsRefs.origem} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'origem')} id="origem" className={`${classInput} ${classInputDark}`} value={origem} onFocus={searchBoxFocus} onChange={origemChange}>
                                                {OrigensMercadoria.map(item => <option key={item.codigo} value={item.codigo} >{item.descricao.trim()}</option>)}
                                            </select>

                                            <label htmlFor="origem" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Origem do Produto</label>
                                        </div>

                                    </div>

                                </div>

                                <div className={`flex flex-col sm:flex-row`}>

                                    <div className={`w-full grid gap-6 grid-cols-12 p-4`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300`}>Estoque</span>
                                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-6 2xl:col-span-4`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.estoque} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'estoque')} id="estoque" className={`${classInput} ${classInputDark} opacity-70 cursor-not-allowed`} type="text" inputMode='numeric' placeholder=" " value={estoque} readOnly={true} disabled={true} onFocus={searchBoxFocus} onChange={estoqueChange} />
                                            <label htmlFor="estoque" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} cursor-not-allowed `}>Estoque</label>
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-6 2xl:col-span-4`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.estoqueFis} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'estoqueFis')} id="estoque_fisico" className={`${classInput} ${classInputDark} opacity-70 cursor-not-allowed `} type="text" inputMode='numeric' placeholder=" " value={estoqueFisico} readOnly={true} disabled={true} onFocus={searchBoxFocus} onChange={estoqueFisicoChange} />
                                            <label htmlFor="estoque_fisico" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} cursor-not-allowed `}>Estoque Físico</label>
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-6 2xl:col-span-4`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.estoqueMin} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'estoqueMin')} id="estoque_minimo" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={estoqueMinimo} onBlur={handleBlurEstoqueMin} onFocus={searchBoxFocus} onChange={estoqueMinimoChange} />
                                            <label htmlFor="estoque_minimo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Estoque Mín</label>
                                        </div>

                                    </div>

                                    <div className={`w-full grid gap-6 grid-cols-12 p-4 sm:h-[50px]`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300`}>Financeiro</span>
                                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-6 2xl:col-span-4`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.precoCusto} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'precoCusto')} id="preco_c" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' placeholder=" " value={precoCusto} onBlur={handleBlurPcusto} onFocus={searchBoxFocus} onChange={hadleChangePCusto} />
                                            <label htmlFor="preco_c" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Preço de Custo</label>
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-6 2xl:col-span-4 `}>

                                            <div className={`${barraVermelhoAzul} ${parseFloat(precoVenda.replace(",", ".")) > 0 ? bgBlue : bgRed}`} />
                                            <input ref={inputsRefs.precoVenda} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'precoVenda')} id="preco_v" className={`${classInput} ${classInputDark} ${parseFloat(precoVenda.replace(",", ".")) > 0 ? '' : focusRed} `} type='text' inputMode='numeric' placeholder=" " value={precoVenda} onBlur={handleBlurPvenda} onFocus={searchBoxFocus} onChange={hadleChangePVenda} />
                                            <label htmlFor="preco_v" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${parseFloat(precoVenda.replace(",", ".")) > 0 ? '' : focusLabelRed} `}>Preço de Venda</label>
                                        </div>

                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/produtos" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>

                                    <button tabIndex={-1} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt}`} onClick={NovoProduto}>
                                        <AiOutlineClear size="20px" className='mr-[5px]' />Limpar Campos
                                    </button>

                                    <button tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`} onClick={handleSaveProducts}>
                                        {!loading && <IoSave size="16px" className='mr-[5px]' />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(idProd || '0') > 0 || id != 0 ? !loading ? 'Atualizar' : 'Aguarde' : !loading ? 'Salvar' : 'Aguarde'}
                                    </button>
                                </div>

                            </div>
                            { /* Dados Principais */}

                            { /* Imagens */}
                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative`}>

                                <input id='inputSelectImage' onChange={handleChangeImage} className='hidden' type='file' accept='image/png, image/jpg, image/jpeg' />

                                <div className={`w-full h-7 ml-4`}>
                                    <span className={`text-xs font-sans dark:text-slate-200`}>*Serão aceitas somente arquivo no formato .png e .jpg com tamanho máximo de 1Mb</span>
                                </div>

                                <div className={`ml-4`}>
                                    <button tabIndex={-1} onClick={handleSelectImage} className={`${classBt} ${classbtVerde} max-w-[150px] my-2`}>

                                        {!loadingImage &&
                                            <IoCamera size="20px" className={`mr-[5px]`} />
                                        }

                                        {loadingImage &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }

                                        {loadingImage &&
                                            'Aguarde'
                                        }

                                        {!loadingImage &&
                                            'Nova Imagem'
                                        }
                                    </button>

                                </div>

                                <div className={`w-full h-[1px] bg-slate-200 dark:bg-slate-700`} />

                                <div className={`w-full grid gap-12 grid-cols-12 p-4 mt-16`}>

                                    {imagens.map((item, index) => {
                                        return (

                                            <div key={index} className={`col-span-12 sm:col-span-4 lg:col-span-3 xl:col-span-2 flex flex-col w-[150px] h-[150px] text-slate-400 rounded-md border border-slate-300 dark:border-slate-800 transition-all duration-300 hover:border-slate-400 hover:text-slate-500 sm:-mt-10`}>
                                                <div className={`flex justify-end items-center w-full text-red-400 h-6 py-1`}>
                                                    <button onClick={() => handleExcluirImage(index, item)} className={`hover:text-red-500 transition-all duration-300`}>
                                                        {imagens[index].loading &&
                                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-red-400 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                                <span className={`!absolute text-red-400 !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                            </div>
                                                        }

                                                        {!imagens[index].loading &&
                                                            <FaTrashAlt className={`mx-1`} />
                                                        }

                                                    </button>
                                                </div>
                                                <div className={`flex w-full h-full justify-center items-center py-1`}>
                                                    <img style={{ width: 96 }} src={item.url} className={`relative`} alt='Foto do produto' />
                                                </div>
                                            </div>

                                        )

                                    })}
                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/produtos" className={`${classbtColunasVermelho} ${classWeigthBt} ${tabs[0].active || tabs[1].active ? `block` : `hidden`}`}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>

                                    <button tabIndex={-1} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt} ${tabs[0].active || tabs[1].active ? `block` : `hidden`}`} onClick={NovoProduto}>
                                        <AiOutlineClear size="20px" className='mr-[5px]' />Limpar Campos
                                    </button>

                                    <button tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} ${tabs[0].active || tabs[1].active ? `block` : `hidden`}`} onClick={handleSaveProducts}>
                                        {!loading && <IoSave size="16px" className='mr-[5px]' />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(idProd || '0') > 0 || id != 0 ? !loading ? 'Atualizar' : 'Aguarde' : !loading ? 'Salvar' : 'Aguarde'}
                                    </button>
                                </div>

                            </div>
                            { /* Imagens */}

                            { /* Grade de Produtos */}
                            <div className={`${tabs[2].active ? 'block' : 'hidden'} relative`}>

                                <div className={`w-full h-full grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300`}>Pesquisar Grades</span>
                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-2 my-1`}>
                                        <input id="cod_barras_pesquisa" className={`${classInput} ${classInputDark}`} type="text" inputMode='text' placeholder=" " autoComplete='off' value={cod_barra_grade} onFocus={handleInputFocusGrade} onChange={handleCodBarraGradeChange} />
                                        <label htmlFor="cod_barras_pesquisa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Cód.Barras / Ref</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-2 my-1`}>
                                        <SearchBox
                                            dataList={variacaoList}
                                            idRegistro={idVariacao || undefined}
                                            label={prodAttributes?.descVariacao || "Variação"}
                                            componentId='varia'
                                            visibleTAB={visibleSearchBoxVariacao}
                                            setDataClick={handleVariacaoSelectClick}
                                            clearDataClick={handleClearVariacaoSelecionada}
                                            filterDataClick={handleFilterVariacaoClick}
                                            clicado={clickSearchBoxVariacao}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-2 my-1`} >
                                        <SearchBox
                                            dataList={subVariacaoList}
                                            idRegistro={idSubVariacao || undefined}
                                            label={prodAttributes?.descSubVariacao || "Sub Variação"}
                                            componentId='subVaria'
                                            visibleTAB={visibleSearchBoxSubVariacao}
                                            setDataClick={handleSubVariacaoSelectClick}
                                            clearDataClick={handleClearSubVariacaoSelecionada}
                                            filterDataClick={handleFilterSubVariacaoClick}
                                            clicado={clickSearchBoxSubVariacao}
                                        />
                                    </div>

                                    {/* 
                                     <div className={`relative col-span-12 md:col-span-4 xl:col-span-2 my-1`}>
                                        <input id="estoque_grade_pesquisa" className={`${classInput} ${classInputDark} `} type="text" inputMode='numeric' placeholder=" " autoComplete='off' value={estoqueGrade} onChange={handleChangeEstoqueGrade} />
                                        <label htmlFor="estoque_grade_pesquisa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Estoque</label>
                                    </div>
                                    */}

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-2 my-1`}>
                                        <button tabIndex={-1} className={`${classbtColunasAzul} ${classBt} w-full`} onClick={pesquisarGrade}>
                                            {!loading &&
                                                <IoSearch size="16px" className='mr-[5px]' />
                                            }

                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }

                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </button>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-2 my-1`}>
                                        <button tabIndex={-1} className={`${classbtCinzaClaro} ${classBt} w-full`} onClick={limparCamposGrade} >
                                            <AiOutlineClear size="20px" className='mr-[5px]' />
                                            Limpar Campos
                                        </button>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-2 my-1`}>
                                        <button tabIndex={-1} onClick={abrirModalCriarGrade} className={`${classbtVerde} ${classBt} w-full`}>
                                            <IoAddCircleSharp size="20px" className='mr-[5px]' />
                                            Cadastrar Grade
                                        </button>
                                    </div>

                                </div>

                                <div className={`relative overflow-hidden hover:overflow-auto p-4`}>

                                    <div className={`w-full min-w-[1300px]`}>

                                        <ul className={`w-full h-full bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>

                                            <li className={`h-full`}>

                                                <div className={`w-full flex flex-row h-10 font-mono`}>

                                                    <div className={`flex items-center w-[24%] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-3`}>Cód. Barras</span>
                                                    </div>

                                                    <div className={`flex items-center w-[24%] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-3`}>{prodAttributes?.descVariacao || "Variação"}</span>
                                                    </div>

                                                    <div className={`flex items-center w-[22%] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-3`}>{prodAttributes?.descSubVariacao || "Sub Variação"}</span>
                                                    </div>

                                                    <div className={`flex items-center justify-end w-[22%] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-3`}>Estoque</span>
                                                    </div>

                                                    <div className={`flex items-center justify-center w-[8%] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-3`}>Ações</span>
                                                    </div>

                                                </div>

                                            </li>

                                        </ul>

                                    </div>

                                    <div className={`h-auto max-h-[400px] min-w-[1300px] overflow-auto scrollbar-custom dark:scrollbar-custom-dark`}>

                                        <div className={`w-full h-auto bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                            <ul className={`w-full`}>

                                                {gradeList.length > 0 &&
                                                    gradeList.map((item, index) => {
                                                        return (

                                                            <li key={item.id} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>

                                                                <div className={`w-full flex flex-row min-h-[50px] font-mono`}>

                                                                    <div className={`flex items-center w-[24%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                        <span className={`px-3`}>{item.codBarraRef}</span>
                                                                    </div>

                                                                    <div className={`flex items-center w-[24%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                        <span className={`px-3`}>{item.variacao.description}</span>
                                                                    </div>

                                                                    <div className={`flex items-center w-[22%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                        <span className={`px-3`}>{item.subVariacao?.description || ""}</span>
                                                                    </div>

                                                                    <div className={`flex items-center justify-end w-[22%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                        <span className={`px-3`}>{item.saldoEstoque}</span>
                                                                    </div>

                                                                    <div className={`flex items-center justify-center w-[8%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                        <button
                                                                            tabIndex={-1}
                                                                            data-tooltip-content="Excluir Grade" data-tooltip-id={'btn-excluir-' + item.id}
                                                                            onClick={() => handleDeleteGrade((item.id || 0), index)}
                                                                            className={`flex items-center justify-center
                                                                                    text-slate-200 transition-all duration-300
                                                                                    hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                                                                    bg-red-500 ml-2`} >
                                                                            <FaTrashAlt size="15px" />
                                                                        </button>
                                                                        <ToolTips target={'btn-excluir-' + item.id} bgColor='rgb(239, 68, 68)' />
                                                                    </div>

                                                                </div>
                                                            </li>

                                                        )
                                                    })
                                                }

                                                {gradeList.length === 0 &&
                                                    <GridEmpty texto='Nenhuma grade localizada' />
                                                }


                                            </ul>
                                        </div>

                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>
                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/produtos" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>
                                </div>

                            </div>
                            { /* Grade de Produtos */}

                            <div className={`${tabs[3].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoProd" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoProd" className={`${classDtCriarAtt}`}>{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoProd" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoProd" className={`${classDtCriarAtt}`}>{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttProd" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttProd" className={`${classDtCriarAtt}`}>{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttProd" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttProd" className={`${classDtCriarAtt}`}>{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                <ModalExcluirDados
                    show={modalDeleteVisible}
                    isLoading={loadingDeleteGrade}
                    message={modalDeleteMessage}
                    closeModalEvent={fecharModalExclusao}
                    excluirEvent={handleConfirmDeleteGrade}
                    fecharModalEvent={buttonFecharModalExcluirDados}
                />

                <ModalMarcaGrupo
                    setIdMarca={updateIdMarca}
                    setIdGrupo={updateIdGrupo}
                    visible={visible_Modal_Marca_Grupo}
                    modalType={modalType}
                    modalConfirmClick={updateDadosList}
                    closeModal={fecharModalMarcaGrupo}
                />

                <ModalSubGrupo
                    setIdSgrupo={updateIdSubGrupo}
                    visible={visible_Modal_SubGrupo}
                    modalConfirmClick={updateDadosList}
                    closeModal={fecharModalSubGrupo}
                />

                <ModalUniMedida
                    setIdUnidMedida={updateIdUnidade}
                    visible={visible_Modal_UnidMed}
                    modalConfirmClick={updateDadosList}
                    closeModal={fecharModalUnidMedida}
                />

                {/* 
                <ModalCadVariacao
                    visible={modalVariacaoVisible}
                    titulo={descModalCadVariacao}
                    tipoRegistro={tipoVariacao}
                    loading={loadingSaveVariacao}
                    closeModal={() => setModalVariacaoVisible(false)}
                    saveData={(descricao: string) => handleSaveVariacao(descricao)}
                />
                */}

                <ModalCriarGrade
                    visible={visible_Modal_Grade}
                    loading={loadingGrade}
                    SalvarGrade={handleSaveGrade}
                    CloseModalEvent={fecharModalCriarGrade}
                    onClose={fecharModalCriarGrade}
                />

                <ModalImportacao
                    visible={visibleImportacao}
                    formFields={formFields}
                    importarDados={importarDados}
                    closeModalEvent={fecharModalImportacao}
                />

            </div>

        </Template>
    )
}